export interface ITranslations {
  dayOfWeek0: string
  dayOfWeek1: string
  dayOfWeek2: string
  dayOfWeek3: string
  dayOfWeek4: string
  dayOfWeek5: string
  dayOfWeek6: string
  month0_2nd: string
  month1_2nd: string
  month2_2nd: string
  month3_2nd: string
  month4_2nd: string
  month5_2nd: string
  month6_2nd: string
  month7_2nd: string
  month8_2nd: string
  month9_2nd: string
  month10_2nd: string
  month11_2nd: string
  dateTo: string
  dateAt: string
  roomOccupied: string
  roomNext: string
  roomFree: string
  tomorrow: string
  today: string
  allDay: string
}

export const getTranslations = (langCode: string): ITranslations => content[langCode]

const content = {
  cs: {
    dayOfWeek0: 'neděle',
    dayOfWeek1: 'pondělí',
    dayOfWeek2: 'úterý',
    dayOfWeek3: 'středa',
    dayOfWeek4: 'čtvrtek',
    dayOfWeek5: 'pátek',
    dayOfWeek6: 'sobota',
    month0_2nd: 'ledna',
    month1_2nd: 'února',
    month2_2nd: 'března',
    month3_2nd: 'dubna',
    month4_2nd: 'května',
    month5_2nd: 'června',
    month6_2nd: 'července',
    month7_2nd: 'srpna',
    month8_2nd: 'září',
    month9_2nd: 'října',
    month10_2nd: 'listopadu',
    month11_2nd: 'prosince',
    dateTo: 'až',
    dateAt: 'v',
    roomOccupied: 'Právě probíhá',
    roomNext: 'Následující událost',
    roomFree: 'Neprobíhá žádná událost',
    tomorrow: 'Zítra',
    today: 'Dnes',
    allDay: 'Celý den',
  },
}
